import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useTemplateFontSettings } from "styles/templateFontSettings";
import AddUpdateAgendaTemplateCard from "../Card/AddUpdateAgendaTemplateCard";

function AddUpdateAgendaTemplateDialog({ onClose, open, afterUpdateFunc, selectedAgendaTemplate, addAfterTable }) {
    const { titleSize, lineHeight } = useTemplateFontSettings();
    return (
        <Dialog onClose={onClose} open={open} fullWidth maxWidth="lg">
            <DialogTitle style={{ fontSize: titleSize, lineHeight: lineHeight }}>
                {selectedAgendaTemplate ? 'Gündem Şablonu Güncelle' : 'Gündem Şablonu Ekle'}
            </DialogTitle>
            <DialogContent dividers>
                <AddUpdateAgendaTemplateCard
                    afterUpdateFunc={afterUpdateFunc}
                    selectedAgendaTemplate={selectedAgendaTemplate}
                    onClose={onClose}
                    addAfterTable={addAfterTable}
                />
            </DialogContent>
            <DialogActions>
            </DialogActions>
        </Dialog>
    );
}

export default AddUpdateAgendaTemplateDialog